import { render } from "./AiCourseCreatePrompt.vue?vue&type=template&id=edfd7dc0"
import script from "./AiCourseCreatePrompt.vue?vue&type=script&lang=js"
export * from "./AiCourseCreatePrompt.vue?vue&type=script&lang=js"

import "./AiCourseCreatePrompt.vue?vue&type=style&index=0&id=edfd7dc0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__